import { Route } from '../route';

import {
  QUERY_STRING_IMAGE_SHARE_PARAMETER,
  QUERY_STRING_REDIRECT_PARAMETER,
} from './url';

const loginPathWithRedirectTo = (path?: string | null) => {
  const redirectTo = path
    ? `?${QUERY_STRING_REDIRECT_PARAMETER}=${encodeURIComponent(path)}`
    : '';

  return `${Route.LOGIN.path}${redirectTo}`;
};

const urlWithImageShare = (url: string, imagePath: string) => {
  const queryString = `?${QUERY_STRING_IMAGE_SHARE_PARAMETER}=${encodeURIComponent(
    imagePath,
  )}`;

  return `${url}${queryString}`;
};

const urlWithRedirectTo = (url: string, redirectTo: string) => {
  const redirectPath = `?${QUERY_STRING_REDIRECT_PARAMETER}=${encodeURIComponent(
    redirectTo,
  )}`;

  return `${url}${redirectPath}`;
};

export { loginPathWithRedirectTo, urlWithImageShare, urlWithRedirectTo };
